import moment from "moment";

export function splitWordOnCamelCase(word: string) {
    return word.replace(/([a-z])([A-Z])/g, '$1 $2');
};

export function getInitials(name: string) {
    if (!name) return '';

    const words = name.trim().split(' '); 
    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase();
    }
    return words.map(w => w.charAt(0).toUpperCase()).join('');
};

export function getMoneyFormat(amount: number) {
    return amount.toLocaleString('en-IE', {
        style: 'currency',
        currency: 'EUR'
    });
}

export function getEnumKeys<
    T extends string,
    TEnumValue extends string | number,
>(enumVariable: { [key in T]: TEnumValue }) {
    
    for(var m in enumVariable){
        console.log(Object.keys(enumVariable) as Array<T>);
    }
    return Object.keys(enumVariable) as Array<T>;
}

export function stringToDateFormat(value: string) {
    return !value ? "" : moment(value).format('YYYY-MM-DD');
}

export function stringToDateFormatText(value: string) {
    return !value ? "" : moment(value).format('DD/MM/YYYY');
}

export function getFormattedTimezoneOffset() {
    // Create a new Date object for the current time
    const date = new Date();

    // Get the timezone offset in minutes
    const offsetInMinutes = -date.getTimezoneOffset();

    // Calculate hours and minutes from the offset
    const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
    const minutes = Math.abs(offsetInMinutes) % 60;

    // Format the offset with leading zeros
    const formattedOffset =
        `${offsetInMinutes >= 0 ? '+' : '-'}${String(hours).padStart(2, '0')}${String(minutes).padStart(2, '0')}`;

    return formattedOffset;
}
